export default "__VITE_ASSET__BRR1gsTO__"